/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:1076eee8-8566-403c-a64d-6a280105e71a",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_XObfbet4i",
    "aws_user_pools_web_client_id": "7psc52uhegou46q05nefek5a4b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "suit-me-up-generated-images01613-staging",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
